module.exports = __webpack_public_path__ + "img/biaozhun.51b90141.jpg";